import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nodeSearch'
})
export class NodeSearchPipe implements PipeTransform {
    public transform(value: any, searchString: string): any {
    if(value.length===0){
      return value;
    }else{
      searchString=searchString.toLowerCase();
      return value.filter(function(item: any){
        if((item.nodeId.indexOf(searchString.includes(" ")?searchString.split(" ").join("-"):searchString)>-1) || (item.nodeType.split("_").join("").toLowerCase().indexOf(searchString.includes("_")?searchString.split("_").join(""):searchString)>-1)){
          return item;
        }
      })    
    }
  }

}
